var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full w-screen bg-black"},[(_vm.getPrivacyPolicyIsLoading)?_c('LoadingState'):(_vm.getPrivacyPolicyIsError)?_c('ErrorState',{attrs:{"error":_vm.getPrivacyPolicyError,"retry":_vm.fetchPrivacyPolicy}}):_vm._e(),_c('Container',{class:[
      'py-32',
      'flex flex-col items-center justify-between',
      'bg-transparent bg-cover bg-no-repeat bg-center' ]},[_c('BlogBlocks',{attrs:{"content":_vm.privacyPolicyContent}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }